import { getResultByTerm } from '@/features/AudienceManager/services';
export const fetchResultByTerm = (criteriaKey, searchTerm) => {
    return getResultByTerm(criteriaKey, searchTerm).then(response => formatValue(response?.data));
};
const formatValue = (response) => {
    return {
        results: response?.series,
        hasData: response?.has_data,
    };
};
